/* eslint-disable no-use-before-define no-throw-literal */
import React from 'react'
import {FrameIn, getConfig, getBrand, trackPage, setBackFrom, getOwaTcdaoContext} from '../../twd'
import BondDetail from './bond-detail'
import BondOrder from './bond-order'

export default ({view, ...args}) => {

    let dest = view.split('.')[1]
    return <React.Fragment>
        <div style={{background:"#fff"}}>
        <div className="container">
        <div className="row vertical-offset-lg"></div>

        {
            dest === 'bond-detail' ? <BondDetail {...args} /> :
            // dest === 'bond-ladder-builder' ? <LadderBuilder {...args} /> :
            dest === 'bond-order' ? <BondOrder {...args} /> :
            dest === 'bond-portfolio-report' ? <PortfolioReport /> :
            dest === 'get-a-bond-quote' ? <BondQuote {...args} /> :
            dest === 'load-url' ? <LoadUrl {...args} /> :
            dest === 'order-detail' ? <OrderDetail {...args} /> :
            dest === 'price-yield-calculator' ? <PriceYieldCalculator /> :
            dest === 'treasury-auctions' ? <TreasuryAuctions {...args} /> :
            (<div className="universal-message universal-message-danger">
            <div className="universal-message-content">
            <p className="universal-message-heading">
                tool is not yet available
            </p>
            </div>
            </div>)
        }

        <div className="row vertical-offset-lg"></div>
        <hr aria-hidden="true" />
        </div>
        </div>
    </React.Fragment>
}

const LoadUrl = ({url, frameName}) => {
    return <FrameIn src={url} frameName={frameName} />
}

const BondQuote = ({url}) => {
    trackPage('tools.get-a-bond-quote')

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    url = url || `${base}/${owaTcDaoContext}/pkg_order_wrapper.output?p_action_subset=WF`
    return <FrameIn dataName="tools-get-a-bond-quote-frame" src={url} frameName='content' />
}


const OrderDetail = ({orderNo}) => {
    if (!orderNo) {
        throw new Error('tools.order-detail: missing order-no')
    }

    trackPage('tools.order-detail')

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_exec_bond.output?p_order_no=${orderNo}`
    return <FrameIn dataName="tools-order-detail-frame" src={url} height={1650} />
}

const PortfolioReport = () => {
    trackPage('tools.bond-portfolio-report')

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_portfolio_etrade.output`
    return <FrameIn dataName="tools-bond-portfolio-report-frame" src={url} />
}

const TreasuryAuctions = ({from}) => {
    trackPage('tools.treasury-auctions')

    if (from) setBackFrom('treasury-auctions', from)

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_order_wrapper.output?p_action=B&p_price_type=A`
    return <FrameIn dataName="tools-treasury-auctions-frame" src={url} />
}

const PriceYieldCalculator = () => {
    trackPage('tools.price-yield-calculator')

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_calc_bond_online.seed?p_javascript=2&p_id=null&p_data_source=I`
    return <FrameIn dataName="tools-price-yield-calculator-frame" src={url} />
}



// WEBPACK FOOTER //
// ./src/tools-and-resources/tools/tools.js